let logger = null;
export function defaultLogger(level) {
  if (logger) {
    return logger;
  }

  logger = new Logger(level || (process.env.APP_ENV === 'stage' ? Logger.Level.DEBUG : Logger.Level.ERROR));
  return logger;
}

export class Logger {
  constructor(level) {
    this.level = level;
  }

  setLevel(level) {
    this.level = level;
  }

  log(level, message, ctx) {
    if (level >= this.level) {
      console.log(Logger.LevelMapper[level], message, ctx);
    }
  }

  debug(message, ctx) {
    return this.log(Logger.Level.DEBUG, message, ctx);
  }

  info(message, ctx) {
    return this.log(Logger.Level.INFO, message, ctx);
  }

  warning(message, ctx) {
    return this.log(Logger.Level.WARNING, message, ctx);
  }

  error(message, ctx) {
    return this.log(Logger.Level.ERROR, message, ctx);
  }
}

Logger.Level = {
  DEBUG: 0,
  INFO: 1,
  WARNING: 2,
  ERROR: 3,
};

Logger.LevelMapper = Object.keys(Logger.Level);


export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
}

//Get a random element from an array
export function getRandomArrayElement(inArray){
  let randomElement = inArray[getRandomInt(0, inArray.length)];
  return (randomElement);
}